import React, { memo } from 'react';
import { SvgUniqueID } from '@financial/svg-manager';

const IconArrowRightRound = /*#__PURE__*/memo(_ref => {
  let {
    fill = '#242424',
    width = '100%',
    height = '100%',
    viewBox = '0 0 6 10',
    id,
    style = {}
  } = _ref;
  return /*#__PURE__*/React.createElement(SvgUniqueID, {
    id: id
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: viewBox,
    style: style
  }, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    fillRule: "evenodd",
    d: "M5.575 4.624L1.199.25 1.17.221a.46.46 0 0 0-.626.673L4.6 4.948.545 9.003a.46.46 0 0 0 0 .652l.106-.107h.002l-.106.107a.462.462 0 0 0 .65 0l4.378-4.38a.456.456 0 0 0 0-.65"
  })));
});

export { IconArrowRightRound as default };
